export default "__VITE_ASSET__088fa4c8__"